var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter,"addlFilter":_vm.addlFilter,"disableLineFilter":false,"defaultFilter":{val: 'teste'}},on:{"search":_vm.buscar}},[_c('BrModalCadastro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }